export default __webpack_public_path__ + "static/media/logo_gcomm.37e957cd.png";